import { ConversationSummary } from '../core/hub-types';
import { normalise } from '../core/patient-mentions';

/** The hub forwards one message into at most this many conversations at once. */
export const MAX_FORWARD_TARGETS = 10;

/**
 * Where a message may be forwarded: conversations this person can write in (a participant, not archived, not
 * read-only) in the same practice as the one it comes from (someone in several practices sees each practice's own
 * groups and support chat; a message does not cross between practices), other than that one, narrowed by the words
 * typed, most recently active first.
 */
export function forwardTargets(
  conversations: ConversationSummary[],
  sourceId: string,
  query: string,
  titleOf: (c: ConversationSummary) => string,
): ConversationSummary[] {
  const words = normalise(query).split(' ').filter(Boolean);
  const when = (c: ConversationSummary) => Date.parse(c.lastMessageAt ?? c.createdAt ?? '') || 0;
  const practice = conversations.find((c) => c.id === sourceId)?.orgId;
  return conversations
    .filter((c) => c.id !== sourceId && c.access === 'participant' && !c.archivedAt && !c.readOnlyReason)
    .filter((c) => !practice || c.orgId === practice)
    .filter((c) => {
      if (!words.length) return true;
      const title = normalise(titleOf(c));
      return words.every((w) => title.includes(w));
    })
    .sort((a, b) => when(b) - when(a));
}
